




































import {Component, Vue} from 'vue-property-decorator';
import PageSeparator from '../../../components/vui-luma/Ui/PageSeparator.vue';
import EventCard from '../../../components/Events/EventCard.vue';
import {dispatchGetEvents} from '@/store/events/actions';
import {readEvents} from '@/store/events/getters';

@Component({
  components: {
      EventCard,
      PageSeparator,
  },
})
export default class Events extends Vue {
  public async created() {
    await dispatchGetEvents(this.$store);
    const events = readEvents(this.$store);
  }
  get events() {
    return readEvents(this.$store);
  }
}
